export * from './property-filter.pipe';
export * from './title-case.pipe';



// WEBPACK FOOTER //
// ./src/app/shared/pipes/index.ts